import { Breadcrumb } from 'antd';
import { createSonarSelector } from '@lib/selectors';
import { getBreadcrumbs } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { BASE_ROUTES, COPY_SPECIFIC, FULL_ROUTES, SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { NavLink, useLocation } from 'react-router-dom';
import { useCurrentInitiative, useDataSecurityApps, useSonarSelector } from '@hooks';
const routeDisplayLookup = {
    [BASE_ROUTES.ISSUES]: COPY_SPECIFIC.VALIDATION_RULE_ISSUES,
    [BASE_ROUTES.DATA_SECURITY]: COPY_SPECIFIC.APPLICATION_OVERVIEW,
    [BASE_ROUTES.API_VOLUME]: COPY_SPECIFIC.API_VOLUME_EXPLORER,
    [BASE_ROUTES.SYNC]: COPY_SPECIFIC.METADATA_IMPORT
};
const dataSecuritySafeFullRoutes = [
    FULL_ROUTES.DATA_SECURITY_DATA_ACCESS
];
const periscopesSelector = createSonarSelector((state) => { var _a; return (_a = state.application.periscope) === null || _a === void 0 ? void 0 : _a.cards; });
export const BreadcrumbHeader = () => {
    const { pathname } = useLocation();
    const apps = useDataSecurityApps(false, true);
    const currentInitiative = useCurrentInitiative();
    const periscopes = useSonarSelector(periscopesSelector);
    if (pathname === '/' || pathname === FULL_ROUTES.DASHBOARD) {
        return (React.createElement(Breadcrumb, { items: [{
                    key: COPY_SPECIFIC.DASHBOARD,
                    title: COPY_SPECIFIC.DASHBOARD
                }] }));
    }
    if (pathname.includes('periscope') && periscopes.length) {
        return (React.createElement(Breadcrumb, { items: periscopes.map((scope) => ({
                key: scope.id,
                title: scope.name
            })) }));
    }
    const breadcrumbsMap = getBreadcrumbs(pathname, routeDisplayLookup);
    const breadcrumbEntries = Object.entries(breadcrumbsMap);
    const forDataSecurity = breadcrumbEntries[0][0] === FULL_ROUTES.DATA_SECURITY;
    const forDataSecurityRoot = forDataSecurity && breadcrumbEntries.length === 1;
    const shouldStripDataSecurity = forDataSecurity && !forDataSecurityRoot &&
        !dataSecuritySafeFullRoutes.includes(breadcrumbEntries[1][0]);
    if (shouldStripDataSecurity) {
        const [, [, target]] = breadcrumbEntries;
        if (isNaN(Number(target))) {
            breadcrumbEntries.shift();
        }
    }
    if (forDataSecurity && !shouldStripDataSecurity) {
        breadcrumbEntries[0][1] = COPY_SPECIFIC.DATA_SECURITY;
    }
    return (React.createElement(Breadcrumb, { itemRender: (route) => (route.path ? React.createElement(NavLink, { to: route.path }, route.title) : route.title), items: breadcrumbEntries.map((value) => {
            var _a, _b, _c, _d, _e;
            const [link, text] = value;
            const fullRoute = link.slice(1).split('/');
            const id = Number(fullRoute[fullRoute.length - 1]);
            const route = fullRoute[fullRoute.length - 2];
            let displayText = text;
            if (id && route === BASE_ROUTES.INITIATIVES) {
                displayText = (_a = currentInitiative === null || currentInitiative === void 0 ? void 0 : currentInitiative.title) !== null && _a !== void 0 ? _a : '';
            }
            else if (id && route === BASE_ROUTES.APPLICATION_SETUP) {
                const name = (_c = (_b = apps.find((app) => app.applicationId === id)) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '';
                displayText = SETTINGS_DATA_SECURITY_COPY.MONITOR_SETTINGS(name);
            }
            else if (id && route === BASE_ROUTES.DATA_SECURITY) {
                displayText = (_e = (_d = apps.find((app) => app.applicationId === id)) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : '';
            }
            const isLast = value === breadcrumbEntries[breadcrumbEntries.length - 1];
            return {
                key: text,
                path: isLast ? undefined : link,
                title: displayText
            };
        }) }));
};
